import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { Target, Brain, Zap } from 'lucide-react';
import getStyles from './styles';

const UniqueSection = () => {
  const styles = getStyles();

  const uniquePoints = [
    {
      title: 'Not an Internship',
      desc: "You're not here to complete tasks — you're here to build.",
      icon: Target
    },
    {
      title: 'Not a Training Program',
      desc: 'You learn by doing real work on real products.',
      icon: Brain
    },
    {
      title: 'Not Classroom-Based',
      desc: 'Everything is hands-on, market-facing, and execution-first.',
      icon: Zap
    }
  ];

  return (
    <Grid sx={styles.section}>
      <Container maxWidth={'xl'}>
        <Grid sx={styles.container}>
          <Typography variant="h2" sx={styles.title}>
            What Makes This Fellowship Unique?
          </Typography>
          <Grid sx={styles.cardsGrid}>
            {uniquePoints.map((point, idx) => (
              <Card key={idx} sx={styles.uniqueCard}>
                <CardContent sx={styles.cardContent}>
                  <Grid sx={styles.cardIconContainer}>
                    <point.icon style={styles.cardIcon} />
                  </Grid>
                  <Typography variant="h3" sx={styles.cardTitle}>
                    {point.title}
                  </Typography>
                  <Typography sx={styles.cardDescription}>
                    {point.desc}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Grid>
          <Typography sx={styles.quote}>
            &quot;This is where talent meets opportunity&quot;
          </Typography>
        </Grid>
      </Container>
    </Grid>
  );
};

export default UniqueSection;
